import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@mui/material";
import { ConfirmationPopupProps } from "./confirmation-popup.props";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";
import {
	IFileInfo,
	INewNumberModel,
	IRegionalAttribute,
} from "src/types/models/apiModels";
import ActionPanel from "../action-panel/action-panel";

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
	open,
	onClose,
	onConfirm,
	business,
}) => {
	return (
		<>
			<Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
				<DialogTitle>
					<div className="flex items-center justify-center gap-2 w-full p-6">
						<span className="font-Poppins tracking-wider bg-gradient-to-r from-red-600 to-purple-600 text-4xl md:text-6xl font-semibold lg:text-4xl bg-clip-text text-transparent uppercase drop-shadow-2xl">
							Confirm Your Business Information
						</span>
					</div>
				</DialogTitle>
				<DialogContent>
					<>
						<div className="flex flex-col items-start justify-center gap-2 w-full p-6">
							<span className="font-Poppins font-semibold text-2xl uppercase tracking-wider">
								Business Information
							</span>
							<div className="flex flex-col items-start justify-center gap-6 pt-6 w-full">
								<img
									src={business?.info?.logo?.signedUrl}
									alt="Uploaded"
									className="w-24 h-24 rounded-lg"
								/>
								<InputBox
									label={"Business Name"}
									readOnly
									value={business?.info?.name}
									type={"email"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Website"}
									readOnly
									value={business?.info?.website}
									type={"url"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Duns Number"}
									readOnly
									value={business?.info?.dunsNumber}
									type={"url"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Status"}
									readOnly
									value={business?.info?.status}
									type={"url"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Country of Operations"}
									readOnly
									value={business?.info?.countryCode}
									type={"url"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
							</div>
						</div>
						<div className="flex flex-col items-start justify-center gap-2 w-full p-6">
							<span className="font-Poppins font-semibold text-2xl uppercase tracking-wider">
								Primary Contact
							</span>
							<div className="flex flex-col items-center justify-center gap-6 pt-6 w-full">
								<InputBox
									label={"Name"}
									readOnly
									value={`${business?.primaryContact?.firstName || ""} ${business?.primaryContact?.lastName || ""}`.trim()}
									type={"text"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Email"}
									readOnly
									value={business?.primaryContact?.emailId}
									type={"email"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
								<InputBox
									label={"Mobile No"}
									readOnly
									value={`+${business?.primaryContact?.phoneNumber?.countryCode}${business?.primaryContact?.phoneNumber?.number || ""}`.trim()}
									type={"tel"}
									onChange={function (value: string): void {
										console.log(`do nothing.`);
									}}
								></InputBox>
							</div>
						</div>
						<div className="flex flex-col items-start justify-center gap-2 w-full p-6">
							<span className="font-Poppins font-semibold text-2xl uppercase tracking-wider">
								Business Details
							</span>
							<div className="flex flex-col items-start justify-center gap-6 pt-6 w-full">
								{business?.details?.fields.map(
									(
										field: IRegionalAttribute,
										index: number
									) => (
										<InputBox
											key={index}
											label={field.title}
											value={field.value}
											readOnly
											type={"text"}
											onChange={function (
												value: string
											): void {
												console.log(
													`do nothing. ${value}`
												);
											}}
										></InputBox>
									)
								)}
							</div>
						</div>
						<div className="flex flex-col items-start justify-center gap-2 w-full p-6">
							<span className="font-Poppins font-semibold text-2xl uppercase tracking-wider">
								Business Numbers
							</span>
							<div className="flex flex-col items-start justify-center gap-2 pt-6 w-full">
								<div className="bg-slate-800 text-white flex items-center justify-center gap-6 w-full p-2 ">
									<span className="font-Poppins font-semibold text-center text-md w-1/3">
										Number
									</span>
									<span className="font-Poppins font-semibold text-center text-md w-1/3">
										Status
									</span>
									<span className="font-Poppins font-semibold text-center text-md w-1/3">
										Ownership Document
									</span>
								</div>
								{business?.numbers.map(
									(field: INewNumberModel, index: number) => (
										<div
											key={index}
											className="bg-slate-100 hover:bg-slate-200 flex items-center justify-between gap-6 w-full p-2"
										>
											<span className="font-Poppins font-semibold text-md w-1/3">
												{field.number}
											</span>
											<span className="font-Poppins font-semibold text-center text-md w-1/3">
												{field.status}
											</span>
											<span className="font-Poppins font-semibold text-center text-md w-1/3">
												{field.ownershipDocuments.map(
													(
														document: IFileInfo,
														index
													) => (
														<span key={index}>
															{document.fileName}
														</span>
													)
												)}
											</span>
										</div>
									)
								)}
							</div>
						</div>
					</>
				</DialogContent>
				<DialogActions>
					<div className="p-10 w-full">
						<ActionPanel
							primaryButtonLabel={"Confirm"}
							primaryButtonEnabled={true}
							secondaryButtonLabel={"Cancel"}
							secondaryButtonEnabled={true}
							primaryButtonAction={onConfirm}
							secondaryButtonAction={onClose}
						></ActionPanel>
					</div>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ConfirmationPopup;
